// ═══════════════════════════════════════════════════════════════
// AndroidWebOnlyNotice.jsx — shown when an Android TWA user reaches
// a billing/upsell surface that's been gated. Informational only;
// no CTAs that lead to external purchase (Google anti-steering).
// ═══════════════════════════════════════════════════════════════

import React from 'react';
import { Globe, Info } from 'lucide-react';

function AndroidWebOnlyNotice({ heading, body, onClose }) {
  return (
    <div className="max-w-md mx-auto mt-12 px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
            <Globe className="w-5 h-5 text-amber-700" />
          </div>
          <h2 className="text-lg font-semibold text-stone-800">
            {heading || 'Manage your subscription on the web'}
          </h2>
        </div>
        <p className="text-sm text-stone-600 mb-4">
          {body || 'Subscription plans, upgrades, and billing are managed at theargumentor.com from a web browser. Your existing account works normally in the Android app.'}
        </p>
        <div className="bg-stone-50 rounded-lg p-3 flex items-start gap-2">
          <Info className="w-4 h-4 text-stone-500 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-stone-600">
            Sign in at <span className="font-medium">theargumentor.com</span> from any web browser to update payment, view invoices, or change your plan. Changes apply automatically the next time you open this app.
          </p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="mt-4 w-full py-2 bg-stone-100 hover:bg-stone-200 text-stone-700 rounded-lg text-sm font-medium transition-colors"
          >
            Got it
          </button>
        )}
      </div>
    </div>
  );
}

export default AndroidWebOnlyNotice;
